export default function FormSelect({ field, value, error, onChange }) {
  const handleChange = (e) => {
    onChange(field.name, e.target.value);
  };

  return (
    <div className="w-full">
      <label className="block text-sm font-medium text-gray-200 mb-2">
        {field.label}
        {field.required && <span className="text-aw-green font-semibold text-lg ml-1">*</span>}
      </label>
      <select
        name={field.name}
        value={value || ""}
        onChange={handleChange}
        disabled={field.disabled}
        className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 transition-all duration-200 ${
          error
            ? "border-red-500 focus:ring-red-500"
            : "border-gray-300 focus:ring-aw-bluedark"
        } bg-white text-black ${field.disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        <option value="">
          {field.placeholder || `Selecciona ${field.label}`}
        </option>
        {field.options &&
          field.options.map((option, index) => {
            // Support both string array and object array
            const optionValue = typeof option === "string" ? option : option.value;
            const optionLabel = typeof option === "string" ? option : option.label;
            return (
              <option key={index} value={optionValue}>
                {optionLabel}
              </option>
            );
          })}
      </select>
      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
      {field.helpText && !error && (
        <p className="text-xs text-gray-500 mt-1">{field.helpText}</p>
      )}
    </div>
  );
}
